@if (state.loading && isLoaderEnabled) {
    <div class="loading-v3" data-crlat="flashing.loader">
        <div class="dot-flashing"></div>
    </div>
}

@if (handleError) {
    <outlet-status [state]="state">
        <request-error [loadFailed]="true" (reloadFn)="reloadComponent()" />
    </outlet-status>
}

<ng-container #container />
